<div *transloco="let t" class="row">
    <div class="col-md-7">
        <form #form="ngForm" (submit)="submitForm(form)">
            <h2>{{ t('MANDANT.OIDC_DOMAIN.TITLE') }}</h2>
            <h3>{{ t('MANDANT.OIDC_DOMAIN.BESCHREIBUNG') }}</h3>

            <div class="row normal-abstand-top">
                <div class="col-md-12">
                    <input type="text"
                           class="form-control"
                           name="domainSelection"
                           [(ngModel)]="formState().domain"
                           required
                           maxlength="255"
                           [placeholder]="t('MANDANT.OIDC_DOMAIN.DOMAIN_INPUT')"
                           [tooltip]="t('MANDANT.OIDC_DOMAIN.DOMAIN_INPUT')"
                           [attr.aria-label]="t('MANDANT.OIDC_DOMAIN.DOMAIN_INPUT')">
                </div>
            </div>

            <dv-submit-cancel-buttons class="normal-abstand-top"
                                      [isLoading]="isLoading()"
                                      (cancelEvent)="goToAdministrationOverview()"/>
        </form>
    </div>

    <div class="col-md-4 col-md-offset-1">
        <table class="table table-responsive table-striped">
            <caption><h2>{{ t('MANDANT.OIDC_DOMAIN.TABLE_CAPTION') }}</h2></caption>
            <thead>
            <tr>
                <th scope="col">{{ t('MANDANT.OIDC_DOMAIN.DOMAIN_ATTRIBUTE') }}</th>
                <th scope="col">{{ t('MANDANT.OIDC_DOMAIN.COUNT_ATTRIBUTE') }}</th>
            </tr>
            </thead>
            <tbody>
                @for (oidcDomainCountPair of availableDomains(); track oidcDomainCountPair.oidcDomain) {
                    <tr>
                        <td>{{ '@' + oidcDomainCountPair.oidcDomain }}</td>
                        <td>{{ oidcDomainCountPair.count | number }}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
